import type { ReactNode } from 'react'
import { KalqyMark } from './KalqyMark'

/**
 * The Kalqy team's own sign-in page (`#/operator`).
 *
 * 🔴 DELIBERATELY NOT THE SCHOOL LOGIN. The product owner's rule: Kalqy's own
 * door is a different page, not the school/teacher sign-in with a third tab.
 * So it shares nothing visible with `AuthSplit` — no marketing panel, no door
 * tabs, no "new school?" links — and reads as what it is: an internal console
 * that can see every school.
 */
export function OperatorAuthShell({
  children,
  testId,
}: {
  children: ReactNode
  testId?: string
}) {
  const year = new Date().getFullYear()
  return (
    <div data-testid={testId} className="console relative min-h-dvh overflow-hidden bg-[#0e0e0d] font-dash text-white">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.8) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.8) 1px, transparent 1px)',
            backgroundSize: '44px 44px',
          }}
        />
        <div className="absolute -top-48 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-white opacity-[0.07] blur-[120px]" />
      </div>

      <div className="relative mx-auto flex min-h-dvh w-full max-w-[440px] flex-col px-4 py-8 sm:py-12">
        <header className="flex items-center">
          <KalqyMark href={null} tone="inverse" />
        </header>

        <main id="main" className="flex flex-1 flex-col justify-center py-10">
          <div className="rounded-[16px] bg-surface px-7 py-8 text-ink shadow-[0_24px_60px_rgba(0,0,0,0.55)] ring-1 ring-white/10 sm:px-8">
            {children}
          </div>
        </main>

        <p className="text-center text-[12px] text-white/40">© {year} Kalqy Global Private Limited · internal use</p>
      </div>
    </div>
  )
}
